<script setup>
  defineProps(['id', 'name', 'value', 'label', 'leftText', 'rightText', 'size'])
</script>

<template>
  <div class="switch-wrapper">
    <slot name="left-text">
      <span v-if="leftText">{{ leftText }}</span>
    </slot>

    <ToggleSwitch class="custom-form-switch" v-bind="$attrs" />

    <slot name="right-text">
      <span v-if="rightText">{{ rightText }}</span>
    </slot>
  </div>
</template>

<style lang="scss" scoped>
  .switch-wrapper {
    display: flex;
    align-items: center;
    gap: 5px;
  }

  .custom-form-switch {
    flex-shrink: 0;
  }
</style>
